export class LogoutAction {
  public static readonly type = '[Authentication] LogoutAction';
}
